import V1 from '@/system-modules/lock-screen/v1/LockScreenV1'
import { ISysLockScreenModule } from '@/contracts/system-modules/lock-screen/ISysLockScreenModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class LockScreenProvider extends Provider<ISysLockScreenModule>{
  realizations: Record<string, ISysLockScreenModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysLockScreenModule | null } = { module: null }

export function SysLockScreenProviderModule(): ISysLockScreenModule {
  const version = SystemModuleConfig.getLockScreenVersion()

  if(!instance.module){
    instance.module = new LockScreenProvider().module(version)
  }

  return instance.module
}
